import React from 'react';
import { Form, Input } from '../components';

const ResetPasswordForm = ({ value, onChange, helperMessage }) => {
  
  return (
    <>
      <Form.FormGroup>
        <Input autoComplete='off' label="Email" name="email" onChange={onChange} value={value.email} helperMessage={helperMessage}/>
        <Input type="password_strength" label="Password" name="password" onChange={onChange} value={value.password} helperMessage={helperMessage}/>
        <Input type="password" label="Password Confirmation" name="password_confirmation" onChange={onChange} value={value.password_confirmation} helperMessage={helperMessage}/>
      </Form.FormGroup>
    </>
  )
}

export default ResetPasswordForm